import React, { useCallback, useEffect, useState } from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import {
  fetchEventLatencyMetrics,
  fetchReadiness,
} from '../../services/systemHealthService';
import { useWebSocketConnectionStatus } from '../../hooks/useWebSocketData';

/**
 * 통합 관제 상단 — readiness / 이벤트 지연 / WS 요약
 * (미확인 이벤트 뱃지는 표시하지 않음)
 */
const MonitoringOpsChips: React.FC = () => {
  const { connectionStatus, isConnected } = useWebSocketConnectionStatus();
  const [readyStatus, setReadyStatus] = useState<string>('…');
  const [p95Ms, setP95Ms] = useState<number | null>(null);
  const [latencyCount, setLatencyCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const [ready, latency] = await Promise.all([
        fetchReadiness(),
        fetchEventLatencyMetrics(),
      ]);
      setReadyStatus(ready.status || 'unknown');
      setLatencyCount(latency.count);
      setP95Ms(latency.count > 0 ? latency.p95_ms : null);
    } catch {
      setReadyStatus('offline');
      setP95Ms(null);
      setLatencyCount(0);
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30_000);
    return () => clearInterval(t);
  }, [refresh]);

  const readyColor =
    readyStatus === 'ready' ? 'success' : readyStatus === 'degraded' ? 'warning' : 'default';

  const wsColor = isConnected ? 'success' : connectionStatus === 'connecting' ? 'warning' : 'default';

  return (
    <Box sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 0.5, ml: 1, alignItems: 'center' }}>
      <Tooltip title="DB·게이트웨이 HLS·YOLO readiness (/api/health/ready)">
        <Chip size="small" variant="outlined" label={`Ready: ${readyStatus}`} color={readyColor} />
      </Tooltip>
      <Tooltip title="이벤트 생성→알림 경로 P95 (최근 샘플)">
        <Chip
          size="small"
          variant="outlined"
          label={
            p95Ms != null
              ? `이벤트 P95 ${p95Ms.toFixed(0)}ms (n=${latencyCount})`
              : '이벤트 지연 —'
          }
          color={p95Ms != null && p95Ms >= 5000 ? 'warning' : 'default'}
        />
      </Tooltip>
      <Tooltip title="monitoringWebSocket 연결 (EventContext 실시간 이벤트)">
        <Chip size="small" variant="outlined" label={`WS ${connectionStatus}`} color={wsColor} />
      </Tooltip>
    </Box>
  );
};

export default MonitoringOpsChips;
